import * as React from 'react';
import { css, StyleSheet } from 'aphrodite';
import { Colors } from '@lean-body/components/styles';
import { DAILY_LESSON_FUTURE_ICON_OPACITY, DAILY_LESSON_DEFAULT_OPACITY, dailyLessonVolumeSolidColor, } from '@lean-body/src/domain/daily_lesson_volume_colors';
import { DailyLessonDumbbellIcon } from '../atoms/icons/daily_lesson_dumbbell_icon';
import { DailyLessonDumbbellLottieIcon } from '../atoms/icons/daily_lesson_dumbbell_lottie_icon';
import { DailyLessonFlowerIcon } from '../atoms/icons/daily_lesson_flower_icon';
import { DailyLessonFlowerLottieIcon } from '../atoms/icons/daily_lesson_flower_lottie_icon';
import { DailyLessonSunIcon } from '../atoms/icons/daily_lesson_sun_icon';
import { DailyLessonSunLottieIcon } from '../atoms/icons/daily_lesson_sun_lottie_icon';
import { DailyLessonNoteIcon } from '../atoms/icons/daily_lesson_note_icon';
import { DailyLessonNoteLottieIcon } from '../atoms/icons/daily_lesson_note_lottie_icon';
const DAILY_LESSON_ICON_ITEM_KEY_ATTR = 'data-daily-lesson-item-key';
// 指定したアイテムキーのアイコン要素を取得する（吹き出しの位置計測に使用）
export const findDailyLessonIconElement = (container, itemKey) => container.querySelector(`[${DAILY_LESSON_ICON_ITEM_KEY_ATTR}="${itemKey}"]`);
// 先頭（1レッスン目）のアイコン要素を取得する（スクロール基準に使用）
export const findFirstDailyLessonIconElement = (container) => container.querySelector(`[${DAILY_LESSON_ICON_ITEM_KEY_ATTR}]`);
export const HomeDailyLessonIcon = ({ icon, state, volumeColor, itemKey, isSelected, thumbnailUrl, onClick, classObject, }) => {
    const volumeSolidColor = dailyLessonVolumeSolidColor(volumeColor);
    const futureIconMotifClass = FUTURE_ICON_MOTIF_STYLES[volumeColor];
    const thumbnailOverlayColorClass = THUMBNAIL_OVERLAY_COLOR_STYLES[volumeColor];
    return (React.createElement("div", Object.assign({ className: css(styles.item, state === 'completed' && styles.itemShadowCompleted, state === 'future' && styles.itemShadowFuture, isSelected && state !== 'future' && styles.itemSelected, classObject) }, (itemKey != null ? { [DAILY_LESSON_ICON_ITEM_KEY_ATTR]: itemKey } : {}), { onClick: (event) => {
            event.stopPropagation();
            onClick();
        } }), state === 'current' ? (React.createElement(React.Fragment, null,
        icon === 'dumbbell' && (React.createElement(DailyLessonDumbbellLottieIcon, { volumeColor: volumeColor, classObject: styles.currentLottieIcon })),
        icon === 'flower' && (React.createElement(DailyLessonFlowerLottieIcon, { volumeColor: volumeColor, classObject: styles.currentLottieIcon })),
        icon === 'sun' && (React.createElement(DailyLessonSunLottieIcon, { volumeColor: volumeColor, classObject: styles.currentLottieIcon })),
        icon === 'note' && (React.createElement(DailyLessonNoteLottieIcon, { volumeColor: volumeColor, classObject: styles.currentLottieIcon })))) : state === 'completed' && thumbnailUrl != null ? (React.createElement("div", { className: css(styles.thumbnailWrapper) },
        React.createElement("img", { className: css(styles.thumbnail), src: thumbnailUrl, alt: "" }),
        React.createElement("div", { className: css(styles.thumbnailOverlay, thumbnailOverlayColorClass) }))) : (React.createElement(React.Fragment, null,
        icon === 'dumbbell' && (React.createElement(DailyLessonDumbbellIcon, { backgroundColor: Colors.White, color: volumeSolidColor, motifClassObject: futureIconMotifClass })),
        icon === 'flower' && (React.createElement(DailyLessonFlowerIcon, { backgroundColor: Colors.White, color: volumeSolidColor, motifClassObject: futureIconMotifClass })),
        icon === 'sun' && (React.createElement(DailyLessonSunIcon, { backgroundColor: Colors.White, color: volumeSolidColor, motifClassObject: futureIconMotifClass })),
        icon === 'note' && (React.createElement(DailyLessonNoteIcon, { backgroundColor: Colors.White, color: volumeSolidColor, motifClassObject: futureIconMotifClass }))))));
};
const styles = StyleSheet.create({
    item: {
        position: 'relative',
        width: 77,
        height: 78,
        flexShrink: 0,
        transition: 'transform 0.4s cubic-bezier(0.34, 1.56, 0.64, 1)',
        cursor: 'pointer',
        pointerEvents: 'auto',
        borderRadius: '50%',
    },
    itemShadowCompleted: {
        boxShadow: '0px 0px 10px rgba(118, 137, 162, 0.3)',
    },
    itemShadowFuture: {
        boxShadow: '0px 0px 10px rgba(118, 137, 162, 0.1)',
    },
    itemSelected: {
        transform: 'scale(1.1)',
    },
    currentLottieIcon: {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 96,
        height: 96,
    },
    thumbnailWrapper: {
        position: 'relative',
        width: 77,
        height: 78,
    },
    thumbnail: {
        display: 'block',
        width: 77,
        height: 78,
        borderRadius: '50%',
        objectFit: 'cover',
    },
    thumbnailOverlay: {
        position: 'absolute',
        top: 0,
        left: 0,
        width: 77,
        height: 78,
        borderRadius: '50%',
        pointerEvents: 'none',
        opacity: DAILY_LESSON_DEFAULT_OPACITY,
    },
    futureIconMotifGreen: {
        opacity: DAILY_LESSON_FUTURE_ICON_OPACITY,
    },
    futureIconMotifPink: {
        opacity: DAILY_LESSON_FUTURE_ICON_OPACITY,
    },
    futureIconMotifYellow: {
        opacity: DAILY_LESSON_DEFAULT_OPACITY,
    },
    futureIconMotifBlue: {
        opacity: DAILY_LESSON_FUTURE_ICON_OPACITY,
    },
    thumbnailOverlayGreen: {
        backgroundColor: dailyLessonVolumeSolidColor('green'),
    },
    thumbnailOverlayPink: {
        backgroundColor: dailyLessonVolumeSolidColor('pink'),
    },
    thumbnailOverlayYellow: {
        backgroundColor: dailyLessonVolumeSolidColor('yellow'),
    },
    thumbnailOverlayBlue: {
        backgroundColor: dailyLessonVolumeSolidColor('blue'),
    },
});
const THUMBNAIL_OVERLAY_COLOR_STYLES = {
    green: styles.thumbnailOverlayGreen,
    pink: styles.thumbnailOverlayPink,
    yellow: styles.thumbnailOverlayYellow,
    blue: styles.thumbnailOverlayBlue,
};
const FUTURE_ICON_MOTIF_STYLES = {
    green: styles.futureIconMotifGreen,
    pink: styles.futureIconMotifPink,
    yellow: styles.futureIconMotifYellow,
    blue: styles.futureIconMotifBlue,
};
